import allColors from "../../../data/colors.json";
import mapToUppercase from "../../lib/mapToUppercase";

const colorNames = Object.keys(allColors);

const woolColors = colorNames.filter((color) => {
	return (
		color.includes("WOOL") &&
		!color.includes("BLEND") &&
		!color.includes("TWO TONE") &&
		!color.includes("FITTED") &&
		!color.includes("DAD HAT") &&
		!color.includes("5 PANEL") &&
		!color.includes("BEANIE")
	);
});

const twoToneColors = colorNames.filter((color) => {
	return color.includes("TWO TONE") && !color.includes("JAPANESE");
});

const twillColors = colorNames.filter((color) => {
	return (
		color.includes("TWILL") &&
		!color.includes("COTTON") &&
		!color.includes("JAPANESE") &&
		!color.includes("5 PANEL") &&
		!color.includes("BEANIE") &&
		!color.includes("BRUSHED")
	);
});

const corduroyColors = colorNames.filter((color) => {
	return color.includes("6 WALE CORD");
});

const linenColors = colorNames.filter((color) => {
	return color.includes("LINEN");
});

const cashmereColors = colorNames.filter((color) => {
	return color.includes("CASHMERE");
});

const woolBlendColors = colorNames.filter((color) => {
	return color.includes("WOOL BLEND") && !color.includes("FITTED");
});

const cottonTwillColors = colorNames.filter((color) => {
	return color.includes("COTTON TWILL");
});

const japaneseTwillColors = colorNames.filter((color) => {
	return color.includes("JAPANESE TWILL") && !color.includes("TWO TONE");
});

const japaneseTwillTwoToneColors = colorNames.filter((color) => {
	return color.includes("JAPANESE TWILL TWO TONE");
});

const canvasColors = colorNames.filter((color) => {
	return color.includes("CANVAS");
});

const gabardine = colorNames.filter((color) => {
	return color.includes("GABARDINE");
});

const velvet = colorNames.filter((color) => {
	return color.includes("VELVET");
});

const woolFittedColors = colorNames.filter((color) => {
	return color.includes("FITTED MERINO WOOL");
});

const woolBlendFittedColors = colorNames.filter((color) => {
	return color.includes("FITTED WOOL BLEND");
});

const twentyOneWaleCurdoryColors = colorNames.filter((color) => {
	return color.includes("21 WALE CORD") && !color.includes("DAD");
});

const snapbackCurvedColors = colorNames.filter((color) => {
	return color.includes("SNAPBACK CURVED");
});

const dadHatWoolColors = colorNames.filter((color) => {
	return color.includes("DAD HAT WOOL");
});

const colorBlock = colorNames.filter((color) => {
	return color.includes("COLOR BLOCK");
});

const denim = colorNames.filter((color) => {
	return color.includes("DENIM");
});

const currentColor = ["transparent"];

const twentyOneWaleCordDad = colorNames.filter((color) => {
	return color.includes("21 WALE CORD DAD");
});

const fivePanelWool = colorNames.filter((color) => {
	return color.includes("5 PANEL WOOL");
});

const fivePanelTwill = colorNames.filter((color) => {
	return color.includes("5 PANEL TWILL");
});

const fivePanelTrucker = colorNames.filter((color) => {
	return color.includes("5 PANEL TRUCKER");
});

const merinoWoolBeanie = colorNames.filter((color) => {
	return color.includes("MERINO WOOL BEANIE");
});

const fivePanelBrushedTwill = colorNames.filter((color) => {
	return color.includes("5 PANEL BRUSHED TWILL");
});

const fourteenWaleCord = colorNames.filter((color) => {
	return color.includes("14 WALE CORD") && !color.includes("5 PANEL");
});

const fivePanelFourteenWaleCord = colorNames.filter((color) => {
	return color.includes("5 PANEL 14 WALE CORD");
});

const brushedTwill = colorNames.filter((color) => {
	return color.includes("BRUSHED TWILL") && !color.includes("5 PANEL");
});

export const colors: {
	[key: string]: string[];
} = {
	wool: mapToUppercase(woolColors),
	woolFitted: mapToUppercase(woolFittedColors),
	twoTone: mapToUppercase(twoToneColors),
	twill: mapToUppercase(twillColors),
	japaneseTwill: mapToUppercase(japaneseTwillColors),
	japaneseTwillTwoTone: mapToUppercase(japaneseTwillTwoToneColors),
	"6WaleCorduroy": mapToUppercase(corduroyColors),
	cashmere: mapToUppercase(cashmereColors),
	linen: mapToUppercase(linenColors),
	woolBlend: mapToUppercase(woolBlendColors),
	woolBlendFitted: mapToUppercase(woolBlendFittedColors),
	cottonTwill: mapToUppercase(cottonTwillColors),
	canvas: mapToUppercase(canvasColors),
	gabardine: mapToUppercase(gabardine),
	velvet: mapToUppercase(velvet),
	"14WaleCord": mapToUppercase(fourteenWaleCord),
	"5Panel14WaleCord": mapToUppercase(fivePanelFourteenWaleCord),
	"21WaleCorduroy": mapToUppercase(twentyOneWaleCurdoryColors),
	"21WaleCordDad": mapToUppercase(twentyOneWaleCordDad),
	snapbackCurved: mapToUppercase(snapbackCurvedColors),
	dadHatWool: mapToUppercase(dadHatWoolColors),
	colorBlock: mapToUppercase(colorBlock),
	denim: mapToUppercase(denim),
	currentColor: currentColor,
	fivePanelWool: mapToUppercase(fivePanelWool),
	fivePanelTwill: mapToUppercase(fivePanelTwill),
	fivePanelTrucker: mapToUppercase(fivePanelTrucker),
	merinoWoolBeanie: mapToUppercase(merinoWoolBeanie),
	fivePanelBrushedTwill: mapToUppercase(fivePanelBrushedTwill),
	brushedTwill: mapToUppercase(brushedTwill),
};
